import React, { ReactNode } from 'react';

type Props = {
  choices: { value: string; label: string; description?: string }[];
  value: string;
  onChange: (newValue: string) => void;
  label?: string | ReactNode;
};

function RadioPanel({ choices, value, onChange, label }: Props) {
  return (
    <div>
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <div className="flex flex-col rounded-md">
        {choices.map((choice, index) => (
          <div
            tabIndex={0}
            role="radio"
            key={choice.value}
            onClick={() => onChange(choice.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onChange(choice.value);
              }
            }}
            className={`flex p-4 cursor-pointer border ${
              value === choice.value ? 'bg-primary-50 border-primary-200 z-0' : 'bg-white hover:bg-primary-50'
            } ${index === 0 ? 'rounded-t-md' : '-mt-px'} ${index === choices.length - 1 ? 'rounded-b-md' : ''}`}
            aria-checked={value === choice.value}
          >
            {value === choice.value && (
              <span className="mt-0.5 w-4 h-4 min-w-4 rounded-full bg-primary-600 flex items-center justify-center">
                <span className="block rounded-full bg-white w-1.5 h-1.5" />
              </span>
            )}
            {value !== choice.value && (
              <span className="mt-0.5 w-4 h-4 min-w-4 rounded-full bg-white border border-gray-300" />
            )}
            <label className="ml-3 cursor-pointer select-none w-full">
              <div className={`font-medium ${value === choice.value ? 'text-primary-900' : 'text-gray-900 '}`}>
                {choice.label}
              </div>
              <div className={`text-sm ${value === choice.value ? 'text-primary-700' : 'text-gray-500 '}`}>
                {choice.description}
              </div>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RadioPanel;
